import React, { Component } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import Select from 'react-select'
import * as XLSX from 'xlsx'
import withRouter from "../../Utils/withRouter";
import { ConfigContext } from "../../Context/ConfigContext";
import Swal from 'sweetalert2';
import { IconButton, TextBox, convertTo12HourFormat, formatDate, formatTime, getHoursAndMinutes, isNegativeDeviation } from "../../Components/InputElements";
import { NoRecords } from "../../Components/Shimmer";
import { currentDateAndTime, formatDateWithTime } from "../../Constants/constants";
import { decodeData } from "../../Constants/constants";
class AttendenceReport extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      keyword: "",
      from_date: "",
      to_date: "",
      location_id: '',
      department_id: '',
      Department: [],
      Location: [],
      Department: [],
      Location: [],
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      selectOption: '',
      loadingLocation: false,
      punch_in_date: null,
      punch_in_time: null,
      punch_out_address: '',
      punch_in_address: null,
      punch_out_date: null,
      punch_out_time: null,
      decodedData: [],
      viewEmployeeVisitLogs: false,
      showLocation: false,

    };
    this.attendanceLocationInfoRef = React.createRef();
  }
  componentDidMount() {
    this.setState({ loadingList: true }, (prevState) => {
      this.GetList();
      this.GetDepartmentMasters();
      this.GetLocationMasters();

    });
  }
  
  componentDidUpdate(prevProps, prevState) {
    if (prevState.permissions !== this.context.permissions) {
      // console.log("Permissions Updated:", this.context.permissions);
        const { permissions } = this.context;
        if (permissions.length > 0) {
          const queryParams = new URLSearchParams(window.location.search);
          const encodedData = queryParams.get("abs");
          const decodedData = encodedData ? decodeData(encodedData, permissions) : [0];
          if (JSON.stringify(prevState.decodedData) !== JSON.stringify(decodedData)) {
            this.setState({ decodedData });
          }
        } else {
          console.warn("Permissions not yet available. Retrying...");
        }
    }
  }

  GetDepartmentMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.department;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Department: data.map((row) => ({
              value: row.department_id,
              label: row.department_title,
            })),
          }));
        }
      });
  };


  GetLocationMasters = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;
    axios
      .get(`${apiURL}Employees/GetMasters`, { headers })
      .then((response) => {
        var data = response.data.data.location;
        if (response.data.success === true) {
          this.setState((prevState) => ({
            Location: data.map((row) => ({
              value: row.location_id,
              label: row.location_title,
            })),
          }));
        }
      });
  };


  GetList = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    axios
      .get(`${apiURL}Attendance/GetEmployeeAttendance`, {
        params: {
          limit: this.state.limit,
          page: this.state.page,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          attendance_status: this.state.selectOption,
          location_id: this.state.location_id,
          department_id: this.state.department_id,
          date: currentDateAndTime(),

        },
        headers,
      })
      .then((response) => {
        var data = response.data;
        if (response.data.success === true) {
          this.setState({
            rows: data.data,
            next: data.next ?? false,
            prev: data.prev ?? false,
            page: data.page ? data.page : 1,
            total_records: data.total_records ? data.total_records : 0,
            total_pages: data.total_pages ? data.total_pages : 0,
            loadingList: false,
          });
        } else {
          this.setState({ loadingList: false });
        }
      });
  };

  scrollToDiv = () => {
    if (this.attendanceLocationInfoRef.current) {
      this.attendanceLocationInfoRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  };

  GetLocation = () => {
    console.log(this.state.position);
    this.setState({ loadingLocation: true });
    axios.get(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.state.position[0]}&lon=${this.state.position[1]}&zoom=18&addressdetails=1`).then((response) => {
      var data = response.data;
      if (response.data !== 0) {
        setTimeout(() => {
          // Code to execute after 1 second
          this.setState({
            display_name: data.display_name,
            city: data.address.city,
            loadingLocation: false,
          });

        }, 500);
      } else {
        this.setState({ loadingLocation: false });
      }
    });
  }

  showInMap = (positionString, punch_in_date, punch_in_time, punch_in_address,show) => {
    if (!positionString) {
      return
    }
    const positionArray = positionString.split(',').map(Number);
    console.log(positionArray);
    this.setState({
      position: positionArray,
      showLocation: show,
      punch_in_date: punch_in_date,
      punch_in_time: punch_in_time,
      punch_out_address: '',
      punch_in_address: punch_in_address,
      punch_out_date: null,
      punch_out_time: null,
    }, () => {
      this.GetLocation();
    });

  }
  showOutMap = (positionString, punch_out_date, punch_out_time, punch_out_address,show) => {
    if (!positionString) {
      return
    }
    const positionArray = positionString.split(',').map(Number);

    this.setState({
      position: positionArray,
      showLocation: show,
      punch_out_date: punch_out_date,
      punch_out_time: punch_out_time,
      punch_in_address: '',
      punch_out_address: punch_out_address,
      punch_in_date: null,
      punch_in_time: null,
    }, () => {
      this.GetLocation();
    });
  }

  checkIsLeave = (data) => {
    const leaveFromDate = data.employee_leave_from_date;
    const leaveToDate = data.employee_leave_to_date;
    let created_datetime = data.attendance_date;
    const createdDate = created_datetime.split(' ')[0];

    if (data.employee_leave_id) {
      if (createdDate === leaveFromDate) {
        // if (createdDate === "2024-11-11") {
        //   console.log(`createdDate,leaveFromDate,data.employee_leave_from_day_unit`, createdDate, leaveFromDate, data.employee_leave_from_day_unit);
        //   console.log(`return 1`, data.employee_leave_from_day_unit === "First Half" ? ' / 1' : data.employee_leave_from_day_unit === "Second Half" ? ' / 2' : '');
        // }
        return data.employee_leave_from_day_unit === "First Half" ? ' / 1' : data.employee_leave_from_day_unit === "Second Half" ? ' / 2' : '';
      }
      if (createdDate === leaveToDate) {
        // if (createdDate === "2024-11-11") {
        //   console.log(`createdDate,leaveToDate,data.employee_leave_to_day_unit`, createdDate, leaveToDate, data.employee_leave_to_day_unit);
        //   console.log(`return 2`, data.employee_leave_to_day_unit === "First Half" ? ' / 1' : data.employee_leave_to_day_unit === "Second Half" ? ' / 2' : '');
        // }
        return data.employee_leave_to_day_unit === "First Half" ? ' / 1' : data.employee_leave_to_day_unit === "Second Half" ? ' / 2' : '';
      }
    } else {
      return '';
    }
  }

  calculateWorkingHours = (data) => {
    let shiftStart = data?.ShiftStart;
    let shiftEnd = data?.ShiftEnd;
    let punchIn = data?.PunchIn?.split(" ")[1]
    let punchOut = data?.PunchOut?.split(" ")[1]
    if (shiftStart && shiftEnd && punchIn && punchOut) {
      // Helper function to parse time strings into Date objects
      const parseTime = (timeStr) => {
        const [hours, minutes] = timeStr.split(':').map(Number);
        return new Date(0, 0, 0, hours, minutes);
      };

      // Helper function to calculate the difference in hours between two Date objects
      const calculateHoursDifference = (start, end) => {
        const millisecondsPerHour = 1000 * 60 * 60;
        return (end - start) / millisecondsPerHour;
      };

      // Parse times
      const shiftStartTime = parseTime(shiftStart);
      const shiftEndTime = parseTime(shiftEnd);
      const punchInTime = parseTime(punchIn);
      const punchOutTime = parseTime(punchOut);

      // Calculate total working hours
      let totalWorkingHours = calculateHoursDifference(shiftStartTime, shiftEndTime);

      // Calculate half of the total working hours
      const halfWorkingHours = totalWorkingHours / 2;

      // Calculate punch hours
      let punchHours = calculateHoursDifference(punchInTime, punchOutTime);
      // Compare punch hours with half of the working hours
      return punchHours >= halfWorkingHours;
    }
    else {
      return false;
    }


  }


  handleExcelDownload = () => {
    const { apiURL, apiHeaderJSON } = this.context;
    const headers = apiHeaderJSON;

    Swal.fire({
      title: 'Please wait...',
      html: 'Your file is being prepared for download.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    axios
      .get(`${apiURL}Attendance/GetEmployeeAttendance`, {
        params: {
          limit: this.state.total_records,
          excel_export: true,
          page: 1,
          keyword: this.state.keyword,
          from_date: this.state.from_date,
          to_date: this.state.to_date,
          attendance_status: this.state.selectOption,
          location_id: this.state.location_id,
          department_id: this.state.department_id,
          export_data: true,
          date: currentDateAndTime()

        },
        headers,
      }).then((response) => {
        if (response.data.success === true) {
          const rows = response.data.data;

          const data = rows.map(row => ({
            'Employee Code': row.employee_code,
            'Employee Name': row.employee_name,
            'Date': formatDate(row.Date),
            'Punch In': `${row.PunchIn ? formatDate(row.PunchIn) : ""} - ${row.PunchIn ? formatTime(row.PunchIn) : "-"}`,
            'Punch In Address': `${row.punch_in_address ? row.punch_in_address : row.PunchIn && !row.punch_in_address ? "Location is not captured." : "--"}`,
            'Punch Out': `${row.PunchOut ? formatDate(row.PunchOut) : ""} - ${row.PunchOut ? formatTime(row.PunchOut) : "-"}`,
            'Punch Out Address': `${row.punch_out_address ? row.punch_out_address : row.PunchOut && !row.punch_out_address ? "Location is not captured." : "--"}`,
            'Shift': `${convertTo12HourFormat(row.ShiftStart)} - ${convertTo12HourFormat(row.ShiftEnd)}`,
            'Working Hours': getHoursAndMinutes(row.WorkingHours),
            // 'Deviation': getHoursAndMinutes(row.Deviation),
            'Location': row.location_title,
            'Department': row.department_title,
            'Attendance Status': row?.employee_leave_id ? (
              this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2"
                ? this.calculateWorkingHours(row)
                  ? "Half Day"
                  : "Half Day Absent"
                : `${row?.leave_type_name}`
            ) : row?.calendar_festivals_name ? (
              "Holiday"
            ) : row?.ShiftWeekOff === "WeekOff" ? (
              row?.ShiftWeekOff
            ) : (
              row?.AttendanceStatus
            ),
            'Action Status': row.regularizationRequestStatus,
            'Regularization Type': row.regularizationType,
            'Remark': row.remark_by_manager,
            'Reason': row.remark_by_employee,
          }));

          const columns = [
            { header: 'Employee Code', key: 'Employee Code', width: 30 },
            { header: 'Employee Name', key: 'Employee Name', width: 30 },
            { header: 'Date', key: 'Date', width: 20 },
            { header: 'Punch In', key: 'Punch In', width: 15 },
            { header: 'Punch In Address', key: 'Punch In Address', width: 15 },
            { header: 'Punch Out', key: 'Punch Out', width: 15 },
            { header: 'Punch Out Address', key: 'Punch Out Address', width: 15 },
            { header: 'Shift', key: 'Shift', width: 20 },
            { header: 'Working Hours', key: 'Working Hours', width: 20 },
            // { header: 'Deviation', key: 'Deviation', width: 20 },
            { header: 'Location', key: 'Location', width: 20 },
            { header: 'Department', key: 'Department', width: 20 },
            { header: 'Attendance Status', key: 'Attendance Status', width: 20 },
            { header: 'Action Status', key: 'Action Status', width: 20 },
            { header: 'Regularization Type', key: 'Regularization Type', width: 20 },
            { header: 'Remark', key: 'Remark', width: 40 },
            { header: 'Reason', key: 'Reason', width: 40 },
          ];


          const wb = XLSX.utils.book_new();

          const ws = XLSX.utils.json_to_sheet(data, { header: columns.map(column => column.header) });

          ws['!cols'] = columns.map(column => ({ wch: column.width }));

          XLSX.utils.sheet_add_json(ws, data, { skipHeader: true, origin: 'A2' });

          columns.forEach((column, index) => {
            ws[XLSX.utils.encode_cell({ r: 0, c: index })] = { v: column.header };
          });

          XLSX.utils.book_append_sheet(wb, ws, 'AbStart Attendance Report');

          // XLSX.writeFile(wb, `AbStartTeamAttendanceReport_(${Date()}).xlsx`);

          const date = Array.isArray(rows) && rows?.length>0 ? `${formatDate(rows[0]?.attendance_date)?.split("-")[1]}-${formatDate(rows[0]?.attendance_date)?.split("-")[2]}`:"";
          XLSX.writeFile(wb, `Attendance Report ${date}.xlsx`);

          Swal.close();

          Swal.fire({
            title: '<strong>Success</strong>',
            html: 'Your file has been downloaded successfully.',
            icon: 'success'
          });
        } else {
          Swal.close();
          Swal.fire({
            title: '<strong>Error</strong>',
            html: response.data.message,
            icon: 'error'
          });
        }
      })
      .catch((error) => {
        Swal.close();
        Swal.fire({
          title: '<strong>Error</strong>',
          html: error.message,
          icon: 'error'
        });
      });
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  showAll = () => {
    this.setState({ limit: this.state.total_records }, () => {
      this.GetList();
    })
  }
  handleClearAll = () => {
    this.setState({
      location_id: '',
      department_id: '',
      rows: [],
      next: false,
      prev: false,
      page: 1,
      limit: 10,
      total_records: 0,
      total_pages: 0,
      loadingList: false,
      postLoading: false,
      keyword: "",
      from_date: "",
      to_date: "",
      selectOption: '',
    }
      , () => {
        this.GetList();
      });
  };

  handleSelectChange(name, selectedOption) {
    this.setState((prevState) => ({
      [name]: selectedOption.value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  }

  handleInputSearch = () => {
    this.GetList();
  }


  handlePrev = (ev) => {
    if (this.state.prev === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page - 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleNext = () => {
    if (this.state.next === true) {
      this.setState(
        (prevState) => {
          return { page: prevState.page + 1 };
        },
        () => {
          this.GetList();

        }
      );
    }
  };
  handleChange = (e) => {
    this.setState(
      (prevState) => {
        return { page: parseInt(e.target.value, 10) };
      },
      () => {
        this.GetList();
      }
    );
  };
  getDuration = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);

    // Calculate the difference in milliseconds
    const durationMs = end - start;

    // Convert milliseconds to human-readable format
    const milliseconds = durationMs % 1000;
    let seconds = Math.floor((durationMs / 1000) % 60);
    let minutes = Math.floor((durationMs / (1000 * 60)) % 60);
    let hours = Math.floor((durationMs / (1000 * 60 * 60)) % 24);
    const days = Math.floor(durationMs / (1000 * 60 * 60 * 24));

    // Add leading zeros if necessary
    seconds = seconds < 10 ? "0" + seconds : seconds;
    minutes = minutes < 10 ? "0" + minutes : minutes;
    hours = hours < 10 ? "0" + hours : hours;

    return hours;
  }
  handleLimitChange = (e) => {
    this.setState(
      {
        limit: parseInt(e.target.value, 10),
        page: 1,
      },
      () => {
        this.GetList();
      }
    );
  };

  render() {
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const options = [
      { value: '0', label: 'Absent' },
      { value: '1', label: 'Present' },
      { value: '2', label: 'Half Day' },
    ];
    const { loadingLocation } = this.state;

    return (
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <br />
            <PageTitle title={`Attendance Report`} primary={`Home`} />
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className='col-md-3'>
                        <label htmlFor="keyword">Enter name</label>
                        <div className="input-group">
                          <input type="search" className="form-control" onChange={this.handleInputChange} name="keyword" value={this.state.keyword} aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Search by name" />
                          <button className="btn btn-success" onClick={this.handleInputSearch} type="button" id="button-addon2"><i className="ri-search-line"></i></button>
                        </div>
                      </div>
                      <div className='col-md-3'>
                        <TextBox type="Date" id="from_date" name="from_date" label="From date" value={this.state.from_date} change={this.handleInputChange} />
                      </div>
                      <div className='col-md-3'>
                        <TextBox type="Date" id="to_date" name="to_date" label="To date" value={this.state.to_date} change={this.handleInputChange} />
                      </div>
                      <div className="col-md-3 position-relative">
                        <div style={{ zIndex: 10, width: "90%" }} className=' position-absolute' >
                        <label>Status</label>
                          <Select
                            onChange={(selectedOption) => this.handleSelectChange('selectOption', selectedOption)}
                            options={options}
                            value={this.state.selectOption ? options.find(option => option.value === this.state.selectOption) : null}
                            placeholder={`Select Status`}
                          />
                        </div>
                      </div>
                      <div className="col-md-3 position-relative">                         
                        <div style={{ zIndex: 9, width: "90%" }} className=' position-absolute' >
                        <label>Location</label>
                        <Select
                          value={this.state.location_id ? this.state.Location.find(option => option.value === this.state.location_id) : null}
                          options={this.state.Location}
                          onChange={(selectedOption) => this.handleSelectChange('location_id', selectedOption)}
                          placeholder={`Select Location`}
                        />
                      </div>
                      </div>
                      <div className="col-md-3 position-relative">                         
                        <div style={{ zIndex: 8, width: "90%" }} className=' position-absolute' >
                        <label> Department </label>
                        <Select
                          value={this.state.department_id ? this.state.Department.find(option => option.value === this.state.department_id) : null}
                          options={this.state.Department}
                          onChange={(selectedOption) => this.handleSelectChange('department_id', selectedOption)}
                          placeholder={`Select Department`}
                        />
                      </div>
                      </div>
                      <div className='col-md-3 mt-3'>
                        <div className="row">
                          <div className='col-md-6'>
                            <div>
                              <label>Apply Filter</label>
                            </div>
                            <button
                              type="button"
                              onClick={this.handleInputSearch}
                              disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption && !this.state.location_id && !this.state.department_id}
                              className={`btn w-100 noWrap btn-info btn-label waves-effect waves-light `}>
                              <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                              Filter
                            </button>
                          </div>
                          <div className='col-md-2'>
                            <div>
                              <label className="noWrap">Clear Filter</label>
                            </div>
                            <button
                              type="button"
                              disabled={!this.state.keyword && !this.state.from_date && !this.state.to_date && !this.state.selectOption && !this.state.location_id && !this.state.department_id}
                              className={`btn noWrap btn-secondary btn-label waves-effect waves-light `}
                              onClick={this.handleClearAll}
                            >
                              <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i>Clear</button>
                          </div>

                        </div>

                      </div>
                      { this.state.decodedData?.includes(6) && ( 
                      <div className='col-md-3 mt-3'>
                        <div className="row">
                          <div className='col-md-12'>
                            <div>
                              <label>Export Excel</label>
                            </div>
                            <button
                              type="button"
                              onClick={this.handleExcelDownload}
                              className={`${this.state.rows.length === 0 ? ('disabled') : ""} btn noWrap btn-success btn-label waves-effect waves-light`}>
                              <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                              Export Excel
                            </button>
                          </div>
                        </div>
                      </div>)}
                    </div>
                  </div>
                  <div ref={this.attendanceLocationInfoRef} className=" " >
                    {/* <div className="card-header">
                                                </div> */}
                    {this.state.showLocation === "1" && (
                      <div className={`${this.state.punch_in_date || this.state.punch_out_date ? '' : 'd-none'} card-header position-relative`}>
                        <h6 className={`${this.state.punch_in_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center`}>
                          <span className='bx bx-log-in fs-3' style={{ marginRight: "10px" }} />
                          <span>Punch In Date : {this.state.punch_in_date} , Time : {this.state.punch_in_time}</span>
                        </h6>
                        <h6 className={`${this.state.punch_out_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center`}>
                          <span className='bx bx-log-out fs-3' style={{ marginRight: "10px" }} />
                          <span>Punch Out Date : {this.state.punch_out_date} , Time : {this.state.punch_out_time}</span>
                        </h6>
                        <h6 className={`card-title`}>
                          <span className='ri ri-map-pin-2-line fs-3' style={{ marginRight: "10px" }}></span>
                          <span>{this.state.punch_in_date === null ? (this.state.punch_out_address) : this.state.punch_in_address}</span>
                        </h6>
                        <span onClick={() => { this.setState({ showLocation: false }) }} style={{ right: "1rem", top: "1rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                      </div>)}
                  </div>
                  <div className="card-body">
                    {/* <div className='card mt-3'>
                      <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                        <table style={{ width: '200%', minWidth: '1200px' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                          <thead className='bg-primary text-light bg-gradient'>
                            <tr>
                              <th>Employee code</th>
                              <th>Employee name</th>
                              <th>Date</th>
                              <th>Punch In</th>
                              <th>Punch Out</th>
                              <th>Shift</th>
                              <th>Working Hours</th>
                              <th>Deviation</th>
                              <th>Location</th>
                              <th>Department</th>
                              <th>Attendance Status</th>
                              <th>Action</th>
                              <th>Action Status</th>
                              <th>Reason</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.rows.map((row) => {
                              return (
                                <tr>
                                  <td>{row.employee_code}</td>
                                  <td>{row.employee_name}</td>
                                  <td>{formatDate(row.Date)}</td>
                                  <td>{formatTime(row.PunchIn)}</td>
                                  <td>{formatTime(row.PunchOut)}</td>
                                  <td>{convertTo12HourFormat(row.ShiftStart)} - {convertTo12HourFormat(row.ShiftEnd)}</td>
                                  <td>{getHoursAndMinutes(row.WorkingHours)}</td>
                                  <td>
                                    <span className={isNegativeDeviation(getHoursAndMinutes(row.Deviation)) ? 'text-danger' : ''}>{getHoursAndMinutes(row.Deviation)}</span>
                                  </td>
                                  <td>{row.location_title}</td>
                                  <td>{row.department_title}</td>
                                  <td ><span className={`badge bg-${row.AttendanceStatusClasses}`}>{row.AttendanceStatus}</span></td>
                                  <td ><span className={`badge bg-${row.regularizationRequestClasses}`}>{row.regularizationRequestStatus}</span></td>
                                  <td>{row.remark_by_employee}</td>
                                  <td>{row.remark_by_manager}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                      <div className="d-flex justify-content-between align-items-center w-100 p-2">
                        <button
                          disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                          type="button"
                          onClick={() => this.handlePrev()}
                          className={`btn btn-warning btn-label waves-effect waves-light`}
                        >
                          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                          Previous
                        </button>
                        <div
                          className="col-md-4"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {
                            <small>
                              Total Records: {this.state.total_records} |
                              Total Pages: {this.state.total_pages} |
                              Current Page: {this.state.page}
                            </small>
                          }
                        </div>
                        <div className="col-md-2">
                          <select
                            className="form-select"
                            onChange={(e) => this.handleChange(e)}
                          >
                            {Array.from(
                              { length: this.state.total_pages },
                              (_, i) => (
                                <option
                                  selected={this.state.page === i + 1}
                                  key={i}
                                  value={i + 1}
                                >
                                  Page {i + 1}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                        <div className="col-md-2">
                          <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                            {limitOptions.map((option) => (
                              <option key={option} value={option}>
                                Limit {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <button
                          disabled={
                            this.state.next === false &&
                              this.state.loadingList === false
                              ? true
                              : false
                          }
                          type="button"
                          onClick={() => this.handleNext()}
                          className={`btn btn-primary btn-label waves-effect right waves-light`}
                        >
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                          Next
                        </button>
                      </div>
                    </div> */}
                    <div className=''>
                      <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                        <table style={{ minwidth: '100%' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                          <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                            <tr>
                              <th>Date</th>
                              <th className='noWrap'>Employee code</th>
                              <th className='noWrap'>Employee name</th>
                              <th className='noWrap'>Punch In</th>
                              <th className='noWrap'>Punch Out</th>
                              <th>Shift</th>
                              <th className='noWrap'>Working Hours</th>
                              {/* <th>Deviation</th> */}
                              <th>Location</th>
                              <th>Department</th>
                              <th className='noWrap'>Attendance Status</th>
                              <th>Action</th>
                              <th className='noWrap'>Action Status</th>
                              <th className='noWrap'>Regularization Type</th>
                              <th>Reason</th>
                              <th>Remark</th>
                            </tr>
                          </thead>
                          {this.state.rows.length === 0 ? (
                            <tbody>
                              <tr>
                                <td colSpan={15}>
                                  <NoRecords />
                                </td>
                              </tr>
                            </tbody>
                          ) :
                            <tbody>
                              {this.state.rows.map((row) => {
                                return (
                                  <tr>
                                    <td className='noWrap'>{formatDate(row?.attendance_date)}</td>
                                    <td className='noWrap'>{row?.employee_code ? row?.employee_code : "--"}</td>
                                    <td style={{ textAlign: "start" }} >{row?.employee_name ? row?.employee_name : "--"}</td>
                                    {/* <td>{formatDate(row?.Date)}</td> */}
                                    <td>
                                      <div className=" d-flex flex-column gap-0 justify-content-start">
                                        <span className='text-info d-flex justify-content-start  noWrap' style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                          if (row?.punch_in_address) {
                                            this.showInMap(row?.punch_in_latlng, formatDate(row?.PunchIn), formatTime(row?.PunchIn), row?.punch_in_address,"1");
                                            this.scrollToDiv();
                                          }
                                        }}>
                                          <span className='noWrap'>{formatDate(row?.PunchIn)} {formatTime(row?.PunchIn)}</span>
                                        </span>
                                        <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                          <small className=' noWrap'>{row?.punch_in_address ? row?.punch_in_address : row?.PunchIn && !row?.punch_in_address ? "Location is not captured." : "--"}</small>
                                        </div>
                                      </div>
                                    </td>
                                    <td >
                                      <div className=" d-flex flex-column gap-0 justify-content-start">
                                        <span className={`text-info d-flex justify-content-start  noWrap ${!row?.PunchOut ? "d-none" : ""}`} style={{ textDecoration: "underline", cursor: "pointer" }} onClick={() => {
                                          if (row?.punch_out_address) {
                                            this.showOutMap(row?.punch_out_latlng, formatDate(row?.PunchOut), formatTime(row?.PunchOut), row?.punch_out_address,"1");
                                            this.scrollToDiv();
                                          }
                                        }}>
                                          <span className=' noWrap'>{formatDate(row?.PunchOut)} {formatTime(row?.PunchOut)}</span>
                                        </span>
                                        <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                          <small className=' noWrap'>{row?.punch_out_address ? row?.punch_out_address : row?.PunchOut && !row?.punch_out_address ? "Location is not captured." : "--"}</small>
                                        </div>
                                      </div>
                                    </td>
                                    <td className='noWrap'>{convertTo12HourFormat(row?.ShiftStart)} - {convertTo12HourFormat(row?.ShiftEnd)}</td>
                                    <td className='noWrap'>{row?.WorkingHours ? getHoursAndMinutes(row?.WorkingHours) : "--"}</td>
                                    {/* <td className='noWrap'>
                                      <span className={isNegativeDeviation(getHoursAndMinutes(row?.Deviation)) ? 'text-danger' : ''}>{getHoursAndMinutes(row?.Deviation)}</span>
                                    </td> */}
                                    <td>{row?.location_title}</td>
                                    <td>{row?.department_title}</td>
                                    <td >
                                      {row?.employee_leave_id ? (
                                        <span className={`badge 
                                          ${this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2" ?
                                            this.calculateWorkingHours(row) ? "bg-warning" : "bg-danger" :
                                            "bg-success"}`}>
                                          {this.checkIsLeave(row) === " / 1" || this.checkIsLeave(row) === " / 2"
                                            ? this.calculateWorkingHours(row)
                                              ? "Half Day"
                                              : "Half Day Absent"
                                            : `${row?.leave_type_code}`}
                                        </span>
                                      ) : row?.calendar_festivals_name ? (
                                        <span className="badge bg-secondary">
                                          Holiday
                                        </span>
                                      ) : row?.ShiftWeekOff === "WeekOff" ? (
                                        <span className={`badge bg-${row?.ShiftWeekOffClasses}`}>
                                          {row?.ShiftWeekOff}
                                        </span>
                                      ) : (
                                        <span className={`badge bg-${row?.AttendanceStatusClasses}`}>
                                          {row?.AttendanceStatus}
                                        </span>
                                      )}
                                    </td>
                                    {/* <td>
                                      <div className='d-flex justify-content-around'>
                                        {
                                          (
                                            row?.attendance_status === 0 ||
                                            row?.attendance_status === 2 ||
                                            row?.attendance_status === 5 ||
                                            row?.attendance_status === 6 ||
                                            row?.attendance_status === 7 ||
                                            (row?.regularization_request_status === 3 || row?.regularization_request_status === null)
                                          )
                                            && getDaysDifference(formatDate(row?.created_date)) <= this.state.rz_data.regularization_apply_days
                                            && this.state.rz_data.rm_apply_regularization === '1' ?
                                            (
                                              <>
                                                <button
                                                  type="button"
                                                  className="btn btn-sm btn-outline-primary"
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#exampleModalgrid"
                                                  onClick={() => this.setState({
                                                    employee_id: row?.employee_id,
                                                    employee_attendance_id: row?.employee_attendance_id,
                                                    attendance_regularization_request_id: row?.attendance_regularization_request_id,
                                                    modal_type: 1
                                                  }, () => this.GetInfo())}
                                                >
                                                  Regularize
                                                </button>
                                                <NavLink to={'/MyLeaves'}>
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-success mx-3"
                                                  >
                                                    Leave
                                                  </button>
                                                </NavLink>
                                              </>
                                            ) : ''
                                        }
                                        {row?.attendance_regularization_request_id && <button
                                          type="button"
                                          className="btn btn-sm btn-info"
                                          data-bs-toggle="modal"
                                          data-bs-target="#exampleModalgrid"
                                          onClick={() => this.setState({ employee_id: row?.employee_id, employee_attendance_id: row?.employee_attendance_id, attendance_regularization_request_id: row?.attendance_regularization_request_id, modal_type: 2 }, (prevState) => this.GetRegularizationLogs())}
                                        >
                                          Details
                                        </button>}
                                      </div> 
                                    </td> */}
                                    <td >
                                    { row?.multi_punch_data?.length > 0 && (
                                        <IconButton
                                        onClick={() => {this.setState({viewEmployeeVisitLogs: row?.multi_punch_data})}} type='success' 
                                        icon='ri-file-info-line' tooltipName='Logs' tooltipPosition='bottom'/>
                                    ) }
                                    </td>
                                    <td ><span className={`badge bg-${row?.regularizationRequestClasses}`}>{row?.regularizationRequestStatus ? row?.regularizationRequestStatus : "--"}</span></td>
                                    <td style={{ textAlign: "start" }} className='noWrap'>{row?.regularizationType}</td>
                                    <td style={{ textAlign: "start" }} className={`${row?.remark_by_manager?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row?.remark_by_employee ? row?.remark_by_employee : "--"}</td>
                                    <td style={{ textAlign: "start" }} className={`${row?.remark_by_manager?.length >= 30 ? "textEllipse" : "noWrap"}`}>{row?.remark_by_manager ? row?.remark_by_manager : "--"}</td>
                                  </tr>
                                );
                              })}
                            </tbody>}
                            {/* <tfoot className='table-light sticky-bottom z-1'>
                              <tr>
                                  <th colSpan={8} >
                                      <div className="d-flex justify-content-between" >
                                      <button
                                          disabled={this.state.prev === false && this.state.loadingList === false}
                                          type="button"
                                          onClick={() => this.handlePrev()}
                                          className="btn btn-warning btn-label waves-effect waves-light"
                                        >
                                          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                                          Previous
                                        </button>
                                        <div
                                          className="col-md-4"
                                          style={{ display: 'flex', alignItems: 'center' }}
                                        >
                                          <small>
                                            Total Records: {this.state.total_records} | Total Pages: {this.state.total_pages} | Current Page: {this.state.page}
                                          </small>
                                        </div>
                                        <div className="col-md-2">
                                          <select
                                            className="form-select"
                                            onChange={(e) => this.handleChange(e)}
                                          >
                                            {Array.from({ length: this.state.total_pages }, (_, i) => (
                                              <option selected={this.state.page === i + 1} key={i} value={i + 1}>
                                                Page {i + 1}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <div className="col-md-2">
                                          <select
                                            className="form-select"
                                            onChange={this.handleLimitChange}
                                            value={this.state.limit}
                                          >
                                            {this.state.total_records >= 1 && (
                                              <option value={this.state.total_records}>
                                                All
                                              </option>
                                            )}
                                            {limitOptions.map((option) => (
                                              <option key={option} value={option}>
                                                Limit {option}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                        <button
                                          disabled={this.state.next === false && this.state.loadingList === false}
                                          type="button"
                                          onClick={() => this.handleNext()}
                                          className="btn btn-primary btn-label waves-effect right waves-light"
                                        >
                                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                                          Next
                                        </button>
                                      </div>
                                  </th>
                              </tr>
                          </tfoot> */}
                        </table>
                      </div>
                      <div className="d-flex bg-light justify-content-between align-items-center w-100 p-2">
                        <button
                          disabled={this.state.prev === false && this.state.loadingList === false ? true : false}
                          type="button"
                          onClick={() => this.handlePrev()}
                          className={`btn btn-warning btn-label waves-effect waves-light`}
                        >
                          <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" />
                          Previous
                        </button>
                        <div
                          className="col-md-4"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          {
                            <small>
                              Total Records: {this.state.total_records} |
                              Total Pages: {this.state.total_pages} |
                              Current Page: {this.state.page}
                            </small>
                          }
                        </div>
                        <div className="col-md-2">
                          <select
                            className="form-select"
                            onChange={(e) => this.handleChange(e)}
                          >
                            {Array.from(
                              { length: this.state.total_pages },
                              (_, i) => (
                                <option
                                  selected={this.state.page === i + 1}
                                  key={i}
                                  value={i + 1}
                                >
                                  Page {i + 1}
                                </option>
                              )
                            )}
                          </select>
                        </div>
                        <div className="col-md-2">
                          <select className="form-select" onChange={this.handleLimitChange} value={this.state.limit}>
                            {/* <option value={this.state.total_records}>All</option> */}
                            {limitOptions.map((option) => (
                              <option key={option} value={option}>
                                Limit {option}
                              </option>
                            ))}
                          </select>
                        </div>
                        <button
                          disabled={
                            this.state.next === false &&
                              this.state.loadingList === false
                              ? true
                              : false
                          }
                          type="button"
                          onClick={() => this.handleNext()}
                          className={`btn btn-primary btn-label waves-effect right waves-light`}
                        >
                          <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" />
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {this.state.viewEmployeeVisitLogs && (
                    <div className="modal show" style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)", }}  >
                      <div className="modal-dialog modal-xl"
                          style={{ width: "90%" }}>
                          <div className="modal-content">
                          <div className="modal-header">
                              <h5 className="modal-title" id="rmModalLabel">Employee Visited logs</h5>
                              <button type="button" className="btn-close" onClick={()=> this.setState({ viewEmployeeVisitLogs:false })} aria-label="Close" />
                          </div>
                          <div className="modal-body">
                          {this.state.showLocation==="2" && (
                              <div className={`${this.state.punch_in_date || this.state.punch_out_date ? '' : 'd-none'} border-1 border-dark rounded-3 position-relative card-body`}>
                                  <h6 className={`${this.state.punch_in_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center`}>
                                      <span className='bx bx-log-in fs-3' style={{ marginRight: "10px" }} />
                                      <span>Punch In Date : {this.state.punch_in_date} , Time : {this.state.punch_in_time}</span>
                                  </h6>
                                  <h6 className={`${this.state.punch_out_date !== null ? '' : 'd-none'} card-title mb-3 d-flex align-items-center`}>
                                      <span className='bx bx-log-out fs-3' style={{ marginRight: "10px" }} />
                                      <span>Punch Out Date : {this.state.punch_out_date} , Time : {this.state.punch_out_time}</span>
                                  </h6>
                                  <h6 className={`card-title`}>
                                      <span className='ri ri-map-pin-2-line fs-3' style={{ marginRight: "10px" }}></span>
                                      <span>{this.state.punch_in_date === null ? (this.state.punch_out_address) : this.state.punch_in_address}</span>
                                  </h6>
                                  <span onClick={() => { this.setState({ showLocation: false }) }} style={{ right: "1rem", top: "1rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                              </div>)}
                              {/* <h5>Date: {Array.isArray(this.state.viewEmployeeVisitLogs) && this.state.viewEmployeeVisitLogs.length > 0 ? 
                              this.state.viewEmployeeVisitLogs[0]?.attendance_date ? formatDate(this.state.viewEmployeeVisitLogs[0]?.attendance_date) : "--" :"--"}</h5> */}
                              <div style={{ "maxHeight": "65vh", "overflowY": "auto", "overflowX": "auto" }}>
                                  <table className=" position-relative table table-borderless table-hover align-middle mb-0 table-bordered table-stripped">
                                      <thead className='bg-primary text-light bg-gradient sticky-top z-1'>
                                          <tr>
                                              <th style={{ width:"10%"}} className="text-center">Sr.No.</th>
                                              {/* <th>Goal Title</th> */}
                                              <th style={{ width:"45%"}} className="text-center">Visit In</th>
                                              <th style={{ width:"45%"}} className="text-center">Visit Out</th>
                                              {/* <th  style={{ width:"10%"}} className="text-center">Status</th> */}
                                          </tr>
                                      </thead>
                                      {Array.isArray(this.state.viewEmployeeVisitLogs) && this.state.viewEmployeeVisitLogs.length === 0 ? (
                                          <tbody>
                                          <tr>
                                              <td colSpan={11}>
                                              <NoRecords />
                                              </td>
                                          </tr>
                                          </tbody>
                                      ) :
                                          <tbody>
                                          {Array.isArray(this.state.viewEmployeeVisitLogs) && this.state.viewEmployeeVisitLogs.map((row,idx) => {
                                              return (
                                              <tr key={row.employee_id}>
                                                  <td className="text-center">{idx+1}</td>                                                                        
                                                  {/* <td className="text-center">{row?.punch_in_datetime ? formatDate(row?.punch_in_datetime) : "--"}</td>
                                                  <td className="text-center">{row?.punch_out_datetime ? formatDate(row?.punch_out_datetime) : "--"}</td> */}
                                                  <td>
                                                          <div className=" d-flex flex-column gap-0 justify-content-start">
                                                              <span className={`${row.punch_in_address && "cursorPointer"} text-info  d-flex justify-content-start`} 
                                                              style={{ textDecoration: "underline", }} onClick={() => {
                                                                  if (row.punch_in_address) {
                                                                      this.showInMap(row.punch_in_latlng, formatDate(row.punch_in_datetime), formatTime(row.punch_in_datetime), row.punch_in_address, "2")
                                                                  }
                                                              }}>
                                                                  <span className='noWrap'>{formatDate(row.punch_in_datetime)} {formatTime(row.punch_in_datetime)}</span>
                                                              </span>
                                                              <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                  <small>{row.punch_in_address ? row.punch_in_address : row.punch_in_datetime && !row.punch_in_address ? "Location is not captured." : "--"}</small>
                                                              </div>
                                                          </div>
                                                      </td>
                                                      <td >
                                                          <div className=" d-flex flex-column gap-0 justify-content-start">
                                                              <span className={`${row.punch_out_address && "cursorPointer"} text-info  d-flex justify-content-start ${!row.punch_out_datetime ? "d-none" : ""}`} 
                                                              style={{ textDecoration: "underline",}} onClick={() => {
                                                                  if (row.punch_out_address) {
                                                                      this.showOutMap(row.punch_out_latlng, formatDate(row.punch_out_datetime), formatTime(row.punch_out_datetime), row.punch_out_address, "2")
                                                                  }
                                                              }}>
                                                                  <span className=' noWrap'>{formatDate(row.punch_out_datetime)} {formatTime(row.punch_out_datetime)}</span>
                                                              </span>
                                                              <div style={{ width: "139px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                                                  <small>{row.punch_out_address ? row.punch_out_address : row.punch_out_datetime && !row.punch_out_address ? "Location is not captured." : "--"}</small>
                                                              </div>
                                                          </div>
                                                      </td>
                                              </tr>
                                              );
                                          })}
                                          </tbody>}
                                  </table>
                              </div>
                          </div>
                          </div>
                      </div>
                    </div>
                  )}
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(AttendenceReport);
